module.exports = __webpack_public_path__ + "img/c06_unittechresourcefulness_Normal_ua.606424c7.webp";